export const TASK_SEARCH_MODE = {
  MY:'MY',
  ACTIVE: 'ACTIVE',
  TO_ACCEPT: 'TO_ACCEPT',
  ARCHIVED: 'ARCHIVED'
} as const;

export type TaskSearchMode = keyof typeof TASK_SEARCH_MODE;

export enum DefectCategoryBackground {
  RED = '#F44336',
  GREEN = '#4CAF50',
  YELLOW = '#FFEB3B'
}
